import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function arrayMinNotEmptyValidator(min = 1): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const numbersNotEmpty = (control.value as string[]).filter(Boolean).length;

        if (numbersNotEmpty < min) {
            return { arrayMinNotEmpty: { requiredLength: min } };
        }

        return null;
    };
}
